import { defineComponent as _defineComponent } from 'vue'
import NotificationService, { INotificationEvent, NotificationType } from '@/core/notification.service';
import { onMounted, ref } from 'vue';

interface INotificationMessage extends INotificationEvent {
    id?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Toaster',
  setup(__props) {

const messages = ref<INotificationMessage[]>([]);

onMounted(() => {
    NotificationService.onNotification((event: INotificationEvent) => {
        if (messages.value.some(n => n.title === event.title && n.message === event.message)) return;
        const message = eventToMessage(event);
        messages.value.push(message);
        scheduleRemove(message);
    });
});

function generateId() {
    return Math.floor((Math.random() * 1000) + 1);
}

function scheduleRemove(message: INotificationMessage) {
    setTimeout(() => {
        remove(message);
    }, 8000);
}

function remove(message: INotificationMessage) {
    messages.value = messages.value.filter(msg => msg.id !== message.id);
}

function eventToMessage(event: INotificationEvent): INotificationMessage {
    const message: INotificationMessage = event;
    message.id = generateId();
    return message;
}

function typeToBackground(type: NotificationType) {
    return type === NotificationType.SUCCESS
        ? 'u-bg-bright-2'
        : 'u-bg-bright-4';
}

return { __sfc: true,messages, generateId, scheduleRemove, remove, eventToMessage, typeToBackground }
}

})